export const formatStringCase = (str) => {
  if (!str) return null;
  return str.replace(/\w\S*/g, (txt) => (txt.trim() === 'UPS' || txt.trim() === 'CVS'
    ? txt
    : txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase()));
};

export const convertTo12HourString = (timeString) => {
  if (timeString) {
    const hour = parseInt(timeString.split(':')[0], 10) % 12 === 0 ? '12' : parseInt(timeString.split(':')[0], 10) % 12;
    const mins = timeString.split(':')[1];
    const AMPM = parseInt(timeString.split(':')[0], 10) - 12 > 0 ? 'pm' : 'am';

    return `${hour}:${mins}${AMPM}`;
  }
  return null;
};

export const getDisplayHours = (workingHours) => {
  if (workingHours) {
    const timeElapsed = Date.now();
    const today = new Date(timeElapsed);
    const tomorrow = new Date(new Date().getTime() + (24 * 60 * 60 * 1000));
    const getToDay = workingHours.find(({ operationDate }) => operationDate === today.toISOString().substring(0, 10));
    const getTomorrow = workingHours.find(({ operationDate }) => operationDate === tomorrow.toISOString().substring(0, 10));
    return ({ today: getToDay?.displayHours || null, tomorrow: getTomorrow?.displayHours || null });
  }
  return null;
};

export const getDisplayUpsHours = (upsDayOfWeek) => {
  if (upsDayOfWeek) {
    const getToDay = upsDayOfWeek.find(({ Day }) => +Day === new Date().getDay() + 1);
    const getTomorrow = upsDayOfWeek.find(({ Day }) => +Day === new Date().getDay() + 2);
    return ({ today: getToDay?.DisplayHours || null, tomorrow: getTomorrow?.DisplayHours || null });
  }
  return null;
};

export const getDisplayHoursFromLocationService = (hours) => {
  if (hours) {
    const today = new Date();
    const tomorrow = new Date(new Date().getTime() + (24 * 60 * 60 * 1000));
    const getToday = hours.find(({ operationDate }) => operationDate === today.toISOString().substring(0, 10));
    const getTomorrow = hours.find(({ operationDate }) => operationDate === tomorrow.toISOString().substring(0, 10));
    const convertedTodayOpenHours = getToday?.openTime ? convertTo12HourString(getToday?.openTime) : null;
    const convertedTodayCloseHours = getToday?.closeTime ? convertTo12HourString(getToday?.closeTime) : null;
    const convertedTomorrowOpenHours = getTomorrow?.openTime ? convertTo12HourString(getTomorrow?.openTime) : null;
    const convertedTomorrowCloseHours = getTomorrow?.closeTime ? convertTo12HourString(getTomorrow?.closeTime) : null;

    return ({
      today: (convertedTodayOpenHours && convertedTodayCloseHours)
        ? `${convertedTodayOpenHours} - ${convertedTodayCloseHours}`
        : 'Closed',
      tomorrow: (convertedTomorrowOpenHours && convertedTomorrowOpenHours)
        ? `${convertedTomorrowOpenHours} - ${convertedTomorrowCloseHours}`
        : 'Closed',
    });
  }
  return null;
};

export const formatBTItemResponse = (stores) => {
  const items = [];
  stores.map((store) => {
    let storeAvailableItemsCount = 0;
    const { inventories } = store;
    inventories.inventory.map(({ storeInventory }) => {
      const { storeAvailability } = storeInventory;
      if (storeAvailability === 'AVAILABLE') {
        storeAvailableItemsCount += 1;
      }
      return storeInventory;
    });

    items.push({
      storeAvailableItemsCount, ...store,
    });
    return store;
  });
  items.map((item) => {
    Object.keys(item).forEach((key) => {
      if (item[key] === '') {
        delete item[key];
      }
    });
    return item;
  });
  const unavailable = items.filter((item) => item.storeAvailableItemsCount === 0);
  const available = items.filter((item) => !(item.storeAvailableItemsCount === 0));
  return { available, unavailable };
};

export const formattedFccResponse = (stores) => {
  const items = [];
  stores.map((store) => {
    let bopsAvailableItemsCount = 0;
    let bossAvailableItemsCount = 0;
    let availabilityMessage = '';
    let inStorePickupEligibility = false;
    let curbsidePickupEligibility = false;
    const { inventories, attributes } = store;
    inventories.inventory.map(({ storeInventory }) => {
      const { bopsAvailability, bossAvailability, bossAvailabilityMessage } = storeInventory;
      if (bopsAvailability === 'AVAILABLE') {
        bopsAvailableItemsCount += 1;
      }
      if (bossAvailability === 'AVAILABLE') {
        bossAvailableItemsCount += 1;
      }
      if (bossAvailability === 'AVAILABLE' && (bossAvailabilityMessage !== undefined || bossAvailabilityMessage !== '')) {
        availabilityMessage = bossAvailabilityMessage;
      }
      return storeInventory;
    });
    attributes?.attribute.map(({ name, value }) => {
      if (name === 'CURBSIDE_PICKUP') {
        curbsidePickupEligibility = value[0].toLowerCase() === 'true';
      }
      if (name === 'IN_STORE_PICKUP') {
        inStorePickupEligibility = value[0].toLowerCase() === 'true';
      }
      return name;
    });
    items.push({
      inStorePickupEligibility, curbsidePickupEligibility, bopsAvailableItemsCount, bossAvailableItemsCount, availabilityMessage, ...store,
    });
    return store;
  });
  items.map((item) => {
    Object.keys(item).forEach((key) => {
      if (item[key] === '') {
        delete item[key];
      }
    });
    return item;
  });
  const unavailable = items.filter((item) => item.bopsAvailableItemsCount === 0 && item.bossAvailableItemsCount === 0);
  const available = items.filter((item) => !(item.bopsAvailableItemsCount === 0 && item.bossAvailableItemsCount === 0));
  return { available, unavailable };
};

// loops over the FCC response storeInventory and counts the # of BOPS and BOSS items
// also find the matching upc for BOPS and BOSS
export const getPickupItemInfo = (inventories, bagItems) => {
  let bopsItemCount = 0;
  let bossItemCount = 0;
  const bopsItems = [];
  const bossItems = [];
  inventories.inventory.forEach(({ upcNumber, storeInventory }) => {
    if (storeInventory.bopsAvailability === 'AVAILABLE' || storeInventory.bopsAvailability === 'ELIGIBLE') {
      bopsItems.push(bagItems.find((bagItem) => bagItem.upcNumber === upcNumber));
      bopsItemCount++;
    } else if (storeInventory.bossAvailability === 'AVAILABLE') {
      bossItems.push(bagItems.find((bagItem) => bagItem.upcNumber === upcNumber));
      bossItemCount++;
    }
  });

  return {
    bops: {
      itemCount: bopsItemCount,
      items: bopsItems,
    },
    boss: {
      itemCount: bossItemCount,
      items: bossItems,
    },
  };
};

export default {
  formatStringCase,
  getDisplayHours,
  getDisplayUpsHours,
  getDisplayHoursFromLocationService,
  formattedFccResponse,
  getPickupItemInfo,
  formatBTItemResponse,
};
